import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Icon,
  Input,
  Table,
  Button,
  message,
  Modal,
  Checkbox,
  Spin,
  notification
} from "antd";
import F from "../../Functions";
import axios from "axios";
import Pagination from "../../components/pagination";
import { Translate } from "react-translated";
import Cookies from "js-cookie";
import { debounceQuery, removeHeaderTitle } from "../../utils/Constants";
import AgencyModal from "./Modals/AgencyModal";
import { ALL_ACTIVE_AGENCIES_API_URL, AGENCY_MANAGERS_API_URL } from "../../utils/Api_enums";
import CustomAgGridTable from '../../Common-Table/CustomAgGridTable';
import '../../Common-Table/CustomAgGridTable.css';
import CustomHeader from '../../CommonHeader/CustomHeader';
import { useBoundStore } from "../../store/useBoundStore";
import { clearSharedDashboardDateState } from "../../utils/clearSharedDashboardDateState";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class AgencyManagerNew extends Component {
  state = {
    loading: true,
    users: [],
    page: 1,
    total_pages: 0,
    user: {},
    agencies_modal: false,
    agencies_modal_loading: false,
    agencies: [],
    user_agencies: [],
    search: "",
    sortOrders: ""
  };

  loadagency = () => {
    this.loadUsers(1);
    this.setState(prevState => ({
      ...prevState,
      loading: true
    }))
    axios
      // .get("/api/all_active_agencies")
      .get(ALL_ACTIVE_AGENCIES_API_URL)
      .then((res) => {
        this.setState({
          agencies: res.data
        });
      })
      .catch((e) => {
        F.log(e);
      }).finally(() => {
        this.setState(prevState => ({
          ...prevState,
          loading: false
        }))
      })
  }

  componentDidMount = () => {
    this.loadagency()
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { agencies, user_agencies, sortOrders } = this.state;
    if (prevProps.location.state !== this.props.location.state) {
      this.loadagency()
    }

    // Check if user_agencies or sortOrders have changed
    if (
      user_agencies !== prevState.user_agencies ||
      sortOrders !== prevState.sortOrders
    ) {
      if (agencies.length > 0) {
        const updatedAgencies = agencies.map((agency) => ({
          ...agency,
          isChecked: user_agencies.indexOf(agency.id) >= 0,
        }));

        this.setState((prevState) => ({
          ...prevState,
          agencies: updatedAgencies,
        }));
      }
    }


  };
  // loadUsers = (page) => {
  // const filters = [];
  // filters.push({ name: "active", op: "==", val: 1 });
  // filters.push({ name: "user_type", op: "==", val: "AGENCY_MANAGER" });

  // const searchPurify = F.removeSpecialCharactersFromString(this.state.search);

  // if (searchPurify.trim().length > 0) {
  //   filters.push({
  //     or: [
  //       {
  //         name: "first_name",
  //         op: "like",
  //         val: encodeURIComponent("%" + searchPurify + "%")
  //       },
  //       {
  //         name: "last_name",
  //         op: "like",
  //         val: encodeURIComponent("%" + searchPurify + "%")
  //       },
  //       {
  //         name: "email",
  //         op: "like",
  //         val: encodeURIComponent("%" + searchPurify + "%")
  //       }
  //     ]
  //   });
  // }

  loadUsers = (page = 1) => {
    const { search, sort_by, sort_order } = this.state;
    let api = `${AGENCY_MANAGERS_API_URL}?page=${page}`;
    if (search && search.trim()) {
      api += `&search_word=${encodeURIComponent(search.trim())}`;
    }
    if (sort_by && sort_by.trim()) {
      api += `&sort_by=${sort_by}`;
    }
    if (sort_order && sort_order.trim()) {
      api += `&sort_order=${sort_order}`;
    }

    // const api =
    //   "/api/users?page=" +
    //   page +
    //   '&q={"filters":' +
    //   JSON.stringify(filters) +
    //   "}";
    this.setState({ loading: true });
    axios.get(api).then((res) => {
      this.setState({
        loading: false,
        // users: res.data.objects,
        // page: res.data.page,
        // total_pages: res.data.total_pages
        users: res.data.manage_users || [],
        page: res.data.page || 1,
        total_pages: res.data.total_pages || 0
      });
    });
  };

  searchUser = (event) => {
    this.setState({ search: event.target.value }, () => {
      debounceQuery(this.loadUsers.bind(this, 1));
    });
  };

  switchUser = (user) => {
    notification.destroy()
    F.log("User Agency Manager = > ", user);
    this.setState({ loading: true });
    removeHeaderTitle();
    axios
      .post("/api/switchuser/" + user.id)
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success) {
          const user = res.data.user;
          F.log("Success agency manager = > ", user);
          Cookies.set(
            "user_info",
            JSON.stringify({
              first_name: user.first_name,
              last_name: user.last_name,
              email: user.email,
              id: user.id,
              user_type: user.user_type,
              default_date: user.default_date,
              last_login: user.last_login,
              language: user.language,
              active: user.active
            }), {
            secure: true,           //  HTTPS only
            sameSite: 'Lax',        // Add this — fixes the scan finding
            path: '/',              // explicit path
          }
          );
          localStorage.setItem('sa_user_route','/super-admin/agency-manager');
          useBoundStore.getState().resetAgencyInfo();
          clearSharedDashboardDateState();
          this.props.history.push("/dashboard");
          window.location.reload();
        } else {
          message.error(F.translate(`Can't switch to the user.`));
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error(F.translate(`Can't switch to the user.`));
      });
  };
  updateAgencyAssoc(agency_id, checked) {
    // this.setState({
    //   agencies_modal_loading: true
    // });
    var val = 0;
    if (checked) val = 1;
    axios
      .post(
        "/api/update_am_agency_assoc/" +
        this.state.user.id +
        "/" +
        agency_id +
        "/" +
        val
      )
      .then(() => {
        this.loadUserAgencies(this.state.user.id);
        // call this when you want to update the user agencies
      });
  }
  loadUserAgencies(user_id) {
    this.setState({
      agencies_modal_loading: true
    });
    axios.get("/api/am_agencies_assoc/" + user_id).then((res) => {
      var agencies = [];
      for (let i = 0; i < res.data.length; i++) {
        const agency = res.data[i];
        agencies.push(agency.agency_id);
      }
      this.setState({
        agencies_modal_loading: false,
        user_agencies: agencies
      });
    });
  }

  // searchUser = (event) => {
  //   this.setState({ search: event.target.value }, () => {
  //     debounceQuery(this.loadUsers.bind(this, 1));
  //   });
  // };

  refreshInfo = () => {
    localStorage.removeItem("agGridColumnState");

    if (this.state.columnApi) {
      this.state.columnApi.resetColumnState();
      this.state.columnApi.resetColumnGroupState();
    }


    this.setState({ search: "" }, () => {
      this.loadUsers(this.state.page);
    });
  };

  handleCloseModal = () => {
    this.setState({
      agencies_modal: false
    });
  }

  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      columnApi: params.columnApi
    });

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }

  saveState = (params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }



  render() {
    const { loading, users, page, total_pages } = this.state;
    const parentInstance = this;
    // console.log("parentInstance test",parentInstance)
    const data = [];
    for (let i = 0; i < users.length; i++) {
      let user = users[i];

      data.push({
        key: i,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        phone: user.phone,
        action: (
          <div className="right-align">
            <Button
              className="borderRadius-28"
              onClick={() => this.switchUser(user)}
              style={{ marginRight: 20 }}
            >
              <Icon type="export" /> Switch to Agency Manager
            </Button>
            <Button
              className="borderRadius-28"
              onClick={() => {
                this.setState(
                  {
                    agencies_modal: true,
                    user
                  },
                  () => {
                    this.loadUserAgencies(user.id);
                  }
                );
              }}
            >
              <Icon type="edit" /> Agencies
            </Button>
          </div>
        )
      });
    }

    // AgGrid column definitions
    const columnDefs = [
      {
        headerClass: 'custom-ag-header',
        headerName: "First Name",
        field: 'first_name',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['First Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'first_name',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.first_name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Last Name",
        field: 'last_name',
        minWidth: 200,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Last Name'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'last_name',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.last_name}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Email",
        field: 'email',
        minWidth: 250,
        flex: 1,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Email'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'email',
        }),
        cellRendererFramework: (params) => (
          <div>{params.data.email}</div>
        ),
      },
      {
        headerClass: 'custom-ag-header',
        headerName: "Actions",
        field: 'action',
        width: 450,
        sortable: false,
        headerComponent: CustomHeader,
        headerComponentParams: (params) => ({
          headers: ['Actions'],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: 'action',
        }),
        cellRendererFramework: (params) => (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 8, height: '100%', width: '100%' }}>
            {params.data.action.props.children}
          </div>
        ),
      },
    ];



    return (
      <div>
        <Card
          type="inner"
          title={
            <div style={{ paddingTop: 7 }}>
              <Icon type="team" style={{ marginRight: 10, color: "#1890ff" }} />
              Agency Manager
            </div>
          }
          className="tableCard"
          loading={loading}
          extra={
            <div>
              <Row gutter={16}>
                <Col md={50} span={16}>
                  <Input
                    placeholder="Search User"
                    className="borderRadius-28"
                    onChange={(e) => this.searchUser(e)}
                    value={this.state.search}
                    style={{ width: "100%" }}
                    onPressEnter={() => {
                      this.loadUsers(1);
                    }}
                  />
                  {this.state.search ? (
                    <Icon
                      type="close"
                      onClick={() => this.searchUser({ target: { value: "" } })}
                      className="icon-style"
                    />
                  ) : (
                    <Icon
                      type="search"
                      className="icon-style"
                    />
                  )}
                </Col>
                <Col md={50} span={8}>
                  <Button
                    type="primary"
                    className="bg-164897 borderRadius-28"
                    onClick={this.refreshInfo}
                  >
                    <Icon type="reload" />
                    Refresh
                  </Button>
                </Col>
              </Row>
            </div>
          }
        >
          <div style={{ width: '100%', overflowX: 'auto' }}>
            <CustomAgGridTable
              onGridReady={this.onGridReady}
              onColumnMoved={this.saveState}
              onSortChanged={this.saveState}
              onFilterChanged={this.saveState}
              rowDatas={data}
              columnDefss={columnDefs}
              styles={{ minWidth: 900, overflowX: 'auto' }}
            />
          </div>
          <Pagination
            className="pagination-container cpagination"
            current_page={page}
            total_pages={total_pages}
            onClick={(page) => {
              this.loadUsers(page);
            }}
          />
        </Card>
        {/* {this.state.agencies_modal ? (
          <Modal
            title={<Translate text={`Agencies`} />}
            visible={this.state.agencies_modal}
            onCancel={() => this.setState({ agencies_modal: false })}
            footer={
              <div>
                <Button
                  onClick={() => this.setState({ agencies_modal: false })}
                >
                  <Translate text={`Cancel`} />
                </Button>
              </div>
            }
          >
            <Spin
              indicator={antIcon}
              spinning={this.state.agencies_modal_loading}
            >
              <div className="formBox">
                {this.state.agencies.map((agency, i) => (
                  <div key={i}>
                    <Checkbox
                      checked={this.state.user_agencies.indexOf(agency.id) >= 0}
                      onChange={(e) => {
                        this.updateAgencyAssoc(agency.id, e.target.checked);
                      }}
                    >
                      {agency.name}
                    </Checkbox>
                  </div>
                ))}
              </div>
            </Spin>
          </Modal>
        ) : null} */}

        {/* new Agency Modal Component */}
        {
          this.state.agencies_modal > 0 && (
            <AgencyModal isVisible={this.state.agencies_modal}
              closeModal={this.handleCloseModal}
              agencies={this.state.agencies}
              user={this.state.user}
              title={<Translate text={`Agency Assignment`} />}
              parentInstance={parentInstance}
              user_agencies={this.state.user_agencies}
            />
          )
        }
      </div>
    );
  }
}

export default AgencyManagerNew;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/agencymanagernew.js